module.exports = __webpack_public_path__ + "img/activity4_2024.46fc0ea7.png";